export const BUTTON_CELL_SCHEVRON_DISPLAY_NAME = "ButtonCellSchevron";
